<template>
  <div class="schedule-posts-preset-picker">
    <b-list-group>
      <b-list-group-item v-for="(text, value) in options" :key="value">
        <b-form-radio :name="name || 'scheduled-presets'" :value="value" v-model="chosenPreset" @change="changePreset">{{ text }}</b-form-radio>
      </b-list-group-item>
    </b-list-group>

    <scheduled-post-times-picker v-if="chosenPreset === 'CUSTOM'" class="mt-3"
      :value="value" @input="newValue => $emit('input', newValue)"/>
  </div>
</template>

<script>
import ScheduledPostTimesPicker from '@src/components/users/ScheduledPostTimesPicker';

export default {
  props: {
    name: {
      type: String,
      default: null,
    },
    labels: {
      type: Object,
      default: null,
    },
    presets: {
      type: Object,
      default: null,
    },
    showCustom: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: null,
    },
  },
  components: {
    ScheduledPostTimesPicker,
  },
  data: () => ({
    chosenPreset: null,
  }),
  created() {
    this.chosenPreset = (this.presets ? findPreset(this.value, this.presets) : null) ||
      (this.showCustom && this.value ? 'CUSTOM' : null);
  },
  computed: {
    options() {
      return {
        ...this.labels,
        ...(this.showCustom ? { CUSTOM: 'Other' } : null),
      };
    },
  },
  methods: {
    changePreset(key) {
      if (key === 'CUSTOM') {
        this.$emit('input', null);
      } else if (this.presets[key]) {
        this.$emit('input', JSON.parse(JSON.stringify(this.presets[key])));
      } else {
        this.$emit('input', null);
      }
    },
  },
};

function findPreset(times, presets) {
  const compare = JSON.stringify(times, (key, value) => key !== '__typename' && value !== null && value !== undefined ? value : undefined);
  return Object.keys(presets).find(key => compare === JSON.stringify(presets[key]));
}
</script>



// WEBPACK FOOTER //
// src/components/users/ScheduledPostPresetPicker.vue